import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskSurveysRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-surveys',
	path: '/jira/servicedesk/projects/:projectKey/settings/surveys/:surveyId?',
};
